<div class="pagination__container" *transloco="let t; read: 'action-plan-paginator'">
  <div class="pagination__page-index-wrapper">
    <div class="pagination__page-index-editor-container">
      <div
        class="pagination__page-index-arrow-icon-wrapper"
        [class.pagination__page-index-arrow-icon-wrapper--disabled]="canNotStepBack"
      >
        <mat-icon
          class="pagination__page-index-arrow-icon"
          [class.pagination__page-index-arrow-icon--disabled]="canNotStepBack"
          svgIcon="xi_single_arrow_left"
          (click)="onStepBack()"
        ></mat-icon>
      </div>

      <app-inline-edit
        appEditOnEnter
        [control]="pageIndexControl"
        (update)="onPageIndexChanged()"
        class="pagination__page-index-editor"
      >
        <ng-template appViewMode>
          <div class="pagination__page-index-editor--view">
            {{ pageIndexDisplay }}
          </div>
        </ng-template>

        <ng-template appEditMode>
          <input
            [formControl]="pageIndexControl"
            appNumericInput
            appAutoFocus
            autoFocusTimeout="100"
            class="pagination__page-index-editor--edit"
          />
        </ng-template>
      </app-inline-edit>

      <div
        class="pagination__page-index-arrow-icon-wrapper"
        [class.pagination__page-index-arrow-icon-wrapper--disabled]="canNotStepForward"
      >
        <mat-icon
          class="pagination__page-index-arrow-icon"
          [class.pagination__page-index-arrow-icon--disabled]="canNotStepForward"
          svgIcon="xi_single_arrow_right"
          (click)="onStepForward()"
        ></mat-icon>
      </div>
    </div>
    <span>{{ t('page', { index: pageIndexDisplay, allPages: allPagesCount }) }} </span>
  </div>

  <div class="pagination__page-size-wrapper">
    <select
      [(ngModel)]="pageSize"
      (change)="onPageSizeChanged()"
      class="pagination__page-size-select"
    >
      @for (pageSizeOption of pageSizeOptions; track pageSizeOption) {
        <option [value]="pageSizeOption">
          {{ pageSizeOption }}
        </option>
      }
    </select>
    <span>{{ t('items-per-page') }}</span>
  </div>
</div>
